import { User } from '../../user/user.model';
import { RootConfig } from '../core/config.scorecard.model';
import {
    GridType,
    ScorecardGridDirectType,
} from '../core/template-definition.model';
import { Scorecard } from '../scorecard-next.model';
import {
    PeriodType,
    PeriodTypeShallow,
    ScorecardDataDto,
    ScorecardDto,
} from '../scorecard.model';

import { GridTab } from './grid-tab.model';

// these might move
// TODO switch from maps to objects
export type ScorecardTabs = Map<string /* tabId */, ScorecardTab>;
export type ScorecardHistory = Map<PeriodType, ScorecardDto[]>;
export type ScorecardDataset = Map<
    string /* periodType-scorecardId */,
    ScorecardDataDto
>;

// this might move
export interface ScorecardTab {
    pending: {
        reload?: boolean;
        reloadStartTime?: number;
        listData?: boolean;
        export?: boolean;
    };

    tabId: string;
    userId: number;
    displayOrder: number; // TODO
    user: User; // TODO revise. hold onto the full object for now. decide how to cut it down later
    rootConfig?: RootConfig;

    periodTypes?: PeriodTypeShallow[];
    scorecardHistory: ScorecardHistory;
    scorecardDataset: ScorecardDataset;

    selectedPeriodType?: PeriodTypeShallow; // TODO this might move
    selectedScorecardHistory?: ScorecardDto[];
    selectedScorecard?: Scorecard;
    useLiveData?: boolean;

    defaultSelectedSCId?: number;
    logoUrl?: string;

    selectedGridTab?: GridTab;
    directReportGrids?: ScorecardGridDirectType[];
    selectedDirectReportDropdownItem?: GridType;
}

export interface ScorecardState {
    tabs: ScorecardTabs; // maybe not recreate tabs
    selectedTab?: ScorecardTab;

    /** TODO revise. this is temporary means of flushing tabs after auth user has changed */
    authUserId?: number;

    // reserved child states
    // header/ScorecardHeaderState
    // widgets__scorecardTrendChart/ScorecardTrendChart // TODO temporary
    // widgets__grid/GridState // TODO temporary
}

export const defaultState = (): ScorecardState => ({
    tabs: new Map(),
});
